module.exports = __webpack_public_path__ + "static/media/10_sognolucido.7bf1e149.jpg";